import { useState, useCallback } from 'react';
import { useViewMode } from './useViewMode';
import type { ViewMode } from '../components/ui/ViewToggle';

interface UseListStateOptions {
  entityType: string;
  defaultLimit?: number;
  defaultViewMode?: ViewMode;
}

export function useListState({
  entityType,
  defaultLimit = 20,
  defaultViewMode = 'grid',
}: UseListStateOptions) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(defaultLimit);
  const [search, setSearch] = useState('');
  const [viewMode, setViewMode] = useViewMode(entityType, defaultViewMode);

  const handleSearchChange = useCallback((value: string) => {
    setSearch(value);
    setPage(1); // Reset to first page on search
  }, []);

  const handlePageChange = useCallback((newPage: number) => {
    setPage(newPage);
  }, []);

  const handleLimitChange = useCallback((newLimit: number) => {
    setLimit(newLimit);
    setPage(1); // Reset to first page on limit change
  }, []);

  return {
    page,
    limit,
    search,
    viewMode,
    setPage: handlePageChange,
    setLimit: handleLimitChange,
    setSearch: handleSearchChange,
    setViewMode,
  };
}
